import CsText from "./Text";
export default CsText;
